import React from "react";
import ModelViewerUtil from '../../modules/ModelViewer/ModelViewer'
const ModelViewerToggle = () => {
  return (
    <button
      id="pdp-model-viewer-toggle"
      className="pdp-hero__model-viewer-cta"
      onClick={ModelViewerUtil.handleModelViewerShow}
    >
      <span className="pdp-hero__cw-icon pdp-hero__cw-icon--model-viewer"></span>
      <span className="pdp-hero__model-viewer-text">View in 3D</span>
    </button>
  );
};

export default ModelViewerToggle;